/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';


export interface PostFirmwareForceUpdate$Params {

/**
 * The id of the firmware that the router should be set to
 */
  firmwareId: number;

/**
 * The id of the device to update the firmware
 */
  routerId: string;
}

export function postFirmwareForceUpdate(http: HttpClient, rootUrl: string, params: PostFirmwareForceUpdate$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
  const rb = new RequestBuilder(rootUrl, postFirmwareForceUpdate.PATH, 'post');
  if (params) {
    rb.path('firmwareId', params.firmwareId, {});
    rb.path('routerId', params.routerId, {});
  }

  return http.request(
    rb.build({ responseType: 'text', accept: '*/*', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
    })
  );
}

postFirmwareForceUpdate.PATH = '/firmware/update/{routerId}/force-update/{firmwareId}';
